export default __webpack_public_path__ + "static/media/imgCultivo.abac50bc.png";